import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
    daeinPay1Options,
    daeinPay2Options,
    daemulPayOptions,
    emergencyServiceOptions,
    jasonOptions,
    noInsInjuryOptions,
    selfCarDamageAmountOptions,
    selfCarDamageRateOptions,
    selfCarDamageTypeOptions,
} from "@/constants/selectOptions";

const INSURANCE_ITEM_CONFIGS = {
    DAEIN_PAY_1: {
        label: "대인 배상 I",
        coverageOptions: daeinPay1Options,
    },
    DAEIN_PAY_2: {
        label: "대인 배상 II",
        coverageOptions: daeinPay2Options,
    },
    DAEMUL_PAY: {
        label: "대물 배상",
        coverageOptions: daemulPayOptions,
    },
    JASON_DEAD: {
        label: "자동차상해(사망)",
        coverageOptions: jasonOptions,
    },
    JASON_INJURY: {
        label: "자동차상해(부상)",
        coverageOptions: jasonOptions,
    },
    JASON_BLOCK: {
        label: "자동차상해(장해)",
        coverageOptions: jasonOptions,
    },
    SELF_CAR_DAMAGE: {
        label: "자기차량손해",
        // 첫 번째 select: '금액'/'비율'
        // 두 번째 select는 첫 번째 선택값에 따라 selfCarDamageAmountOptions / selfCarDamageRateOptions
    },
    NO_INS_INJURY: {
        label: "무보험차상해",
        coverageOptions: noInsInjuryOptions,
    },
    EMERGENCY_SERVICE: {
        label: "긴급출동",
        coverageOptions: emergencyServiceOptions,
    },
};

export const InsuranceTable = ({ insuranceItems, onUpdateInsuranceItem }) => {
    const [selectAll, setSelectAll] = useState(false);

    // 초기 선택 상태 확인
    useEffect(() => {
        if (insuranceItems?.length > 0) {
            const allSelected = insuranceItems.every((item) => item.joinYn === "Y");
            setSelectAll(allSelected);
        }
    }, [insuranceItems]);

    // joinYn 토글 핸들러
    const handleToggleJoinYn = (index, currentJoinYn) => {
        const nextJoinYn = currentJoinYn === "Y" ? "N" : "Y";
        onUpdateInsuranceItem(index, { joinYn: nextJoinYn });

        // 모든 항목이 선택되었는지 확인
        const allSelected = insuranceItems.every((item) => item.joinYn === nextJoinYn);
        setSelectAll(allSelected);
    };

    // 전체 선택 토글 핸들러
    const handleToggleAll = () => {
        const nextSelectAll = !selectAll;
        setSelectAll(nextSelectAll);

        // 모든 항목의 joinYn을 업데이트
        insuranceItems.forEach((_, index) => {
            onUpdateInsuranceItem(index, { joinYn: nextSelectAll ? "Y" : "N" });
        });
    };

    return (
        <>
            <div className="table-container">
                <div className="table-content">
                    <div className="table-wrapper">
                        <div className="table">
                            <table>
                                <colgroup>
                                    <col width="12%" />
                                    <col width="25%" />
                                    <col width="25%" />
                                    <col width="25%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="cell">
                                                <span
                                                    className="cell-tit"
                                                    style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}
                                                >
                                                    가입 여부{" "}
                                                    <button
                                                        type="button"
                                                        className={`btn-toggle-own ${selectAll ? "active" : ""}`}
                                                        onClick={handleToggleAll}
                                                    />
                                                </span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <span className="cell-tit">종류</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <span className="cell-tit">보상범위</span>
                                            </div>
                                        </th>
                                        <th>
                                            <div className="cell">
                                                <span className="cell-tit">자부담금</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {insuranceItems?.map((item, idx) => {
                                        const config = INSURANCE_ITEM_CONFIGS[item.insuranceItemType];
                                        if (!config) return null;
                                        return (
                                            <tr key={item.insuranceItemType}>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <button
                                                            type="button"
                                                            className={`btn-toggle-own ${item.joinYn === "Y" ? "active" : ""}`}
                                                            onClick={() => handleToggleJoinYn(idx, item.joinYn)}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-desc color-main">{config.label}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="center">
                                                        <span className="cell-input">
                                                            {item.insuranceItemType === "SELF_CAR_DAMAGE" ? (
                                                                <>
                                                                    <Select
                                                                        className="custom-select"
                                                                        classNamePrefix="custom-select"
                                                                        isSearchable={false}
                                                                        placeholder="구분"
                                                                        value={
                                                                            item.selfCarDamageRangeType
                                                                                ? selfCarDamageTypeOptions.find(
                                                                                    (opt) => opt.value === item.selfCarDamageRangeType
                                                                                )
                                                                                : null
                                                                        }
                                                                        onChange={(option) => {
                                                                            onUpdateInsuranceItem(idx, {
                                                                                selfCarDamageRangeType: option.value,
                                                                                compensationRange: null,
                                                                                selfCarDamageRateType: null,
                                                                            });
                                                                        }}
                                                                        options={selfCarDamageTypeOptions}
                                                                        isDisabled={item.joinYn !== "Y"}
                                                                    />
                                                                    {item.selfCarDamageRangeType === "PRICE" && (
                                                                        <Select
                                                                            className="custom-select"
                                                                            classNamePrefix="custom-select"
                                                                            isSearchable={false}
                                                                            placeholder="금액"
                                                                            value={
                                                                                item.compensationRange
                                                                                    ? selfCarDamageAmountOptions.find(
                                                                                        (opt) => opt.value === item.compensationRange
                                                                                    )
                                                                                    : null
                                                                            }
                                                                            onChange={(option) => {
                                                                                onUpdateInsuranceItem(idx, {
                                                                                    compensationRange: option.value,
                                                                                    selfCarDamageRateType: null,
                                                                                });
                                                                            }}
                                                                            options={selfCarDamageAmountOptions}
                                                                            isDisabled={item.joinYn !== "Y"}
                                                                        />
                                                                    )}
                                                                    {item.selfCarDamageRangeType === "RATE" && (
                                                                        <Select
                                                                            className="custom-select"
                                                                            classNamePrefix="custom-select"
                                                                            isSearchable={false}
                                                                            placeholder="비율"
                                                                            value={
                                                                                item.selfCarDamageRateType
                                                                                    ? selfCarDamageRateOptions.find(
                                                                                        (opt) => opt.value === item.selfCarDamageRateType
                                                                                    )
                                                                                    : null
                                                                            }
                                                                            onChange={(option) => {
                                                                                onUpdateInsuranceItem(idx, {
                                                                                    selfCarDamageRateType: option.value,
                                                                                });
                                                                            }}
                                                                            options={selfCarDamageRateOptions}
                                                                            isDisabled={item.joinYn !== "Y"}
                                                                        />
                                                                    )}
                                                                </>
                                                            ) : item.insuranceItemType === "DAEIN_PAY_1" ? (
                                                                <Select
                                                                    className="custom-select"
                                                                    classNamePrefix="custom-select"
                                                                    isSearchable={false}
                                                                    options={config.coverageOptions}
                                                                    placeholder="보상범위"
                                                                    value={
                                                                        item.limitType
                                                                            ? config.coverageOptions.find(
                                                                                (opt) => opt.value === item.limitType
                                                                            )
                                                                            : null
                                                                    }
                                                                    onChange={(option) => {
                                                                        onUpdateInsuranceItem(idx, {
                                                                            limitType:
                                                                                typeof option.value === "string" ? option.value : null,
                                                                            compensationRange:
                                                                                typeof option.value === "number" ? option.value : null,
                                                                        });
                                                                    }}
                                                                    isDisabled={item.joinYn !== "Y"}
                                                                />
                                                            ) : item.insuranceItemType === "DAEIN_PAY_2" ? (
                                                                <Select
                                                                    className="custom-select"
                                                                    classNamePrefix="custom-select"
                                                                    isSearchable={false}
                                                                    options={config.coverageOptions}
                                                                    placeholder="보상범위"
                                                                    value={
                                                                        item.limitType === "UN_LIMIT"
                                                                            ? config.coverageOptions.find((opt) => opt.value === "UN_LIMIT")
                                                                            : config.coverageOptions.find(
                                                                                (opt) => opt.value === item.compensationRange
                                                                            )
                                                                    }
                                                                    onChange={(option) => {
                                                                        if (option.value === "UN_LIMIT") {
                                                                            onUpdateInsuranceItem(idx, {
                                                                                limitType: "UN_LIMIT",
                                                                                compensationRange: null,
                                                                            });
                                                                        } else {
                                                                            onUpdateInsuranceItem(idx, {
                                                                                limitType: null,
                                                                                compensationRange: Number(option.value),
                                                                            });
                                                                        }
                                                                    }}
                                                                    isDisabled={item.joinYn !== "Y"}
                                                                />
                                                            ) : item.insuranceItemType === "EMERGENCY_SERVICE" ? (
                                                                <Select
                                                                    className="custom-select"
                                                                    classNamePrefix="custom-select"
                                                                    isSearchable={false}
                                                                    options={config.coverageOptions}
                                                                    placeholder="연 횟수"
                                                                    value={
                                                                        item.compensationRange
                                                                            ? config.coverageOptions.find(
                                                                                (opt) => opt.value === item.compensationRange
                                                                            )
                                                                            : null
                                                                    }
                                                                    onChange={(option) => {
                                                                        onUpdateInsuranceItem(idx, {
                                                                            limitType: null,
                                                                            compensationRange: option.value,
                                                                        });
                                                                    }}
                                                                    isDisabled={item.joinYn !== "Y"}
                                                                />
                                                            ) : (
                                                                <Select
                                                                    className="custom-select"
                                                                    classNamePrefix="custom-select"
                                                                    isSearchable={false}
                                                                    options={config.coverageOptions}
                                                                    placeholder="보상범위"
                                                                    value={
                                                                        item.compensationRange
                                                                            ? config.coverageOptions.find(
                                                                                (opt) => opt.value === item.compensationRange
                                                                            )
                                                                            : null
                                                                    }
                                                                    onChange={(option) => {
                                                                        onUpdateInsuranceItem(idx, {
                                                                            limitType: null,
                                                                            compensationRange: Number(option.value),
                                                                        });
                                                                    }}
                                                                    isDisabled={item.joinYn !== "Y"}
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="cell" data-align="left">
                                                        <span className="cell-input">
                                                            <input
                                                                type="number"
                                                                placeholder="0"
                                                                value={item.selfPay || ""}
                                                                onChange={(e) => {
                                                                    const val = e.target.value;
                                                                    onUpdateInsuranceItem(idx, { selfPay: val ? Number(val) : null });
                                                                }}
                                                                disabled={item.joinYn !== "Y"}
                                                            />
                                                            <span className="input-esset">
                                                                {item.insuranceItemType === "EMERGENCY_SERVICE" ? "km" : "원"}
                                                            </span>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
